// MetaGrid/MetaGrid.tsx
import { Grid } from '@nautilusbio/nb-design-system/Grid';
import clsx from 'clsx';
import React, { memo, type ReactNode } from 'react';

import styles from './styles.module.css';

export interface MetaGridProps {
  columns?: number;
  className?: string;
  children: ReactNode;
}

function MetaGridComponent({ columns = 3, className, children }: MetaGridProps) {
  return (
    <Grid className={clsx(styles.grid, className)} gap={4} gridTemplateColumns={`repeat(${columns}, 1fr)`}>
      {children}
    </Grid>
  );
}

export const MetaGrid = memo(MetaGridComponent);
